import React, { useState } from "react";
import { Link } from "react-router-dom";
import Badge from "Utils/Badge/Badge";
import { DetalleCierresPeriodo } from "./DetalleCierresPeriodo";
import { estadoCierreMensual } from "../../../../../helpers/tiposCierreMensual";
import { cierreParaReporte } from "../../../../../helpers/tiposCierreMensual";
import NullableValue from "../../../../../../../Utils/renderField/nullableValue";
import moment from "moment";
const verIcon = require("assets/img/icons/ver.png");
const excelIcon = require("assets/img/icons/download.png");
const rightArrowIcon = require("assets/img/icons/right-arrow.png");

const COLUMNAS = 5;

// Una fila por período: el detalle y el Excel son del período completo, así que
// la fila muestra solo si cada mitad ya está registrada, y al abrirla se ve de
// qué documento salió cada una y se puede anular
export const CierresMensualesTable = ({ periodos, onExportar, onAnular }) => {
    const [filasAbiertas, setFilasAbiertas] = useState([]);

    const AlternarFila = (id) => {
        setFilasAbiertas((previas) =>
            previas.includes(id)
                ? previas.filter((fila) => fila !== id)
                : previas.concat(id),
        );
    };

    return (
        <div className="new-table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th>Período de almacenes</th>
                        <th>Materia prima</th>
                        <th>Bodega de producción</th>
                        <th>Fecha y hora de corte</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {periodos.length === 0 && (
                        <tr>
                            <td colSpan={COLUMNAS} className="text-center">
                                No hay cierres mensuales registrados
                            </td>
                        </tr>
                    )}

                    {periodos.map((item) => (
                        <React.Fragment key={item.id}>
                            <tr
                                className={`cierres-mensuales__fila-periodo ${
                                    filasAbiertas.includes(item.id)
                                        ? "expanded"
                                        : ""
                                }`}
                                onClick={() => AlternarFila(item.id)}
                            >
                                <td className="text-nowrap">
                                    <div className="d-flex align-items-center">
                                        <img
                                            src={rightArrowIcon}
                                            alt="Expandir"
                                            className="action_img expand-icon mr-2"
                                            style={{
                                                width: "14px",
                                                height: "14px",
                                            }}
                                        />
                                        <span>{item.periodo}</span>
                                    </div>
                                </td>
                                <td className="text-center text-nowrap">
                                    <Badge
                                        {...estadoCierreMensual(
                                            item.cierre_materia_prima,
                                        )}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <Badge
                                        {...estadoCierreMensual(
                                            item.cierre_bodega_produccion,
                                        )}
                                    />
                                </td>
                                {/* el corte lo declara la mitad de bodega, así
                                que falta mientras esa mitad no se registre */}
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={
                                            item.cierre_bodega_produccion &&
                                            moment(
                                                item.cierre_bodega_produccion
                                                    .fecha_corte,
                                            ).format("DD/MM/YYYY HH:mm")
                                        }
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <div className="table-actions">
                                        {/* el detalle se pide por un cierre,
                                        pero reconstruye el período entero */}
                                        <Link
                                            to={`/inventarios-almacen/reporte/cierre-mensual/${
                                                cierreParaReporte(item).id
                                            }`}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <img
                                                src={verIcon}
                                                alt="Ver"
                                                className="action_img"
                                                title="Ver"
                                            />
                                        </Link>

                                        {/* el formato es del período completo:
                                        si falta una mitad se descarga igual,
                                        con esa tabla rotulada como pendiente */}
                                        <img
                                            src={excelIcon}
                                            alt="Exportar"
                                            className="action_img"
                                            title={
                                                item.completo
                                                    ? "Exportar Excel"
                                                    : "Exportar Excel (uno de los dos cierres del período se mostrará como pendiente)"
                                            }
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onExportar(item);
                                            }}
                                            style={{
                                                width: "21px",
                                                height: "21px",
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>

                            {filasAbiertas.includes(item.id) && (
                                <tr className="cierres-mensuales__fila-detalle">
                                    <td colSpan={COLUMNAS}>
                                        <DetalleCierresPeriodo
                                            periodo={item}
                                            onAnular={onAnular}
                                        />
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
